import { useState } from "react";
import { tokens, useTheme } from "../../glassTheme.tsx";
import { GlassCard } from "../glass/Glass.tsx";
import { ChevronDown, ChevronUp } from "../icons.tsx";

/** The weekly review's three collapsible, one-screen-tall panels (§1). */
export function Panel({
  title, children, defaultOpen = true,
}: { title: string; children: React.ReactNode; defaultOpen?: boolean }) {
  const { colors } = useTheme();
  const [open, setOpen] = useState(defaultOpen);
  return (
    <GlassCard padding={16} style={{ marginTop: 16 }}>
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%",
          background: "none", border: "none", padding: 0, cursor: "pointer",
        }}
      >
        <span style={{
          fontFamily: tokens.font.sans, fontSize: tokens.type.caption.size,
          letterSpacing: tokens.type.caption.letterSpacing, textTransform: "uppercase",
          fontWeight: 600, color: colors.ink2,
        }}>{title}</span>
        {open ? <ChevronUp size={12} color={colors.ink2} /> : <ChevronDown size={12} color={colors.ink2} />}
      </button>
      {open && <div style={{ marginTop: 12 }}>{children}</div>}
    </GlassCard>
  );
}
